﻿import {Core} from "../../Base/Core";
import {UIText} from "../Tools/Base/UIText";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UISprite} from "../Tools/Base/UISprite";

export class UINoSpace extends UICommonPopup {
    Awake() {
        super.Awake({
            skin: "orange",
        });

        this.planet = this.addChildAt(new UISprite("map/planet1"), 1);

        this.text1 = this.content.addChild(new UIText("16/16"));

        this.text2 = this.content.addChild(new UIText(Core.Localizator.Get("not_enough_space")));
        this.text3 = this.content.addChild(new UIText(Core.Localizator.Get("not_enough_space_msg1")));
        this.text4 = this.content.addChild(new UIText(Core.Localizator.Get("not_enough_space_msg2"), {fill: 0xffa500}));

        this.creature1 = this.content.addChild(new UISprite("creatures/4"));
        this.creature3 = this.content.addChild(new UISprite("creatures/6"));
        this.creature2 = this.content.addChild(new UISprite("creatures/1"));

        this.okBtn = this.content.addChild(new UINineSliceButton("btn-blue", { label: Core.Localizator.Get("ok") }));

        this.epochId = 0;

        this.okBtn.on("pointertap", () => {
            Core.WaitBefore(0.1, () => {
                Core.UI.creatures.Hide();
                this.Hide();
            });
            Core.WaitBefore(0.12, () => {
                GameManager.gameView.SelectEpoch(this.epochId, false, 0);
            });
        });
    }

    Show(epochId) {
        this.epochId = epochId;
        this.planet.setImage(`map/planet${Core.Player.PlanetsSave.CurrentPlanet.planetId || 1}`);
        this.fitLayout();
        super.Show();
    }

    _fitDecorations() {
        let planetRect = this._popupRect.clone();
        planetRect.height = planetRect.width;
        planetRect.y -= planetRect.height * 0.5;
        this.planet.fitRect(planetRect);

        let creaturesRect = planetRect.clone();
        creaturesRect.height *= 0.3;
        creaturesRect.y = -creaturesRect.height;
        creaturesRect.x = 0;

        this.creature2.anchor.set(0.5, 1);
        let midCreatureRect = creaturesRect.clone().pad((creaturesRect.width - creaturesRect.height) * -0.5, 0);
        this.creature2.fitRect(midCreatureRect);

        this.creature1.anchor.set(1, 1);
        this.creature1.rotation = -Math.PI * 0.05;
        this.creature1.scale.set(this.creature2.scale.x * 0.6);
        this.creature1.position.set(midCreatureRect.left + midCreatureRect.width * 0.1, midCreatureRect.bottom);

        this.creature3.anchor.set(0, 1);
        this.creature3.rotation = Math.PI * 0.05;
        this.creature3.scale.set(this.creature2.scale.x * 0.4);
        this.creature3.position.set(midCreatureRect.right - midCreatureRect.width * 0.1, midCreatureRect.bottom);
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.3;
        let w = Math.min(viewport.width * 0.7, (viewport.height * 0.7) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle(
            (viewport.width - w) * 0.5,
            (viewport.height - h) * 0.5 + viewport.height * 0.1,
            w, h
        ));

        super.fitLayout(viewport);
        this._fitDecorations();

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.13;
        rect.width = popupRect.width * 0.55;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.05;
        this.text1.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.15;
        rect.width = popupRect.width * 0.95;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.24;
        this.text2.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.12;
        rect.width = popupRect.width * 0.95;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.45;
        this.text3.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.06;
        rect.width = popupRect.width * 0.8;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.63;
        this.text4.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.42;
        rect.height = popupRect.height * 0.15;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.95;
        this.okBtn.fitLayout(rect);
    }
}
